(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kinetic-prep-fast-home"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.querySelectorAll('[data-prep-fast]').forEach((section) => {
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const cards = section.querySelectorAll('[data-prep-card]');
      const modes = section.querySelectorAll('[data-prep-mode]');
      const revealItems = section.querySelectorAll('[data-prep-reveal]');
      let frame = 0;
      let pointer = null;

      const updatePointer = () => {
        if (!pointer) {
          frame = 0;
          return;
        }
        const rect = section.getBoundingClientRect();
        const x = ((pointer.clientX - rect.left) / rect.width).toFixed(3);
        const y = ((pointer.clientY - rect.top) / rect.height).toFixed(3);
        section.style.setProperty('--pf-x', `${(x * 100).toFixed(1)}%`);
        section.style.setProperty('--pf-y', `${(y * 100).toFixed(1)}%`);
        section.style.setProperty('--pf-tilt-x', (x - 0.5).toFixed(3));
        section.style.setProperty('--pf-tilt-y', (y - 0.5).toFixed(3));
        frame = 0;
      };

      if (!reducedMotion) {
        section.addEventListener('pointermove', (event) => {
          pointer = event;
          if (!frame) frame = window.requestAnimationFrame(updatePointer);
        }, { passive: true });

        section.addEventListener('pointerleave', () => {
          pointer = null;
          if (frame) window.cancelAnimationFrame(frame);
          frame = 0;
          section.style.setProperty('--pf-x', '58%');
          section.style.setProperty('--pf-y', '36%');
          section.style.setProperty('--pf-tilt-x', '0');
          section.style.setProperty('--pf-tilt-y', '0');
        });
      }

      modes.forEach((mode, index) => {
        mode.addEventListener('click', () => {
          modes.forEach((item) => item.classList.remove('is-active'));
          cards.forEach((item) => item.classList.remove('is-active'));
          mode.classList.add('is-active');
          if (cards[index]) cards[index].classList.add('is-active');
        });
      });

      if (reducedMotion) {
        revealItems.forEach((item) => item.classList.add('is-visible'));
        return;
      }

      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.14 });

      revealItems.forEach((item) => observer.observe(item));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kinetic-prep-home"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const sections = document.querySelectorAll('[data-kinetic-prep]');

    sections.forEach((section) => {
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const cards = section.querySelectorAll('[data-kinetic-card]');
      const steps = section.querySelectorAll('[data-kinetic-step]');
      const revealItems = section.querySelectorAll('[data-kinetic-reveal]');

      section.addEventListener('pointermove', (event) => {
        const rect = section.getBoundingClientRect();
        const x = ((event.clientX - rect.left) / rect.width * 100).toFixed(2);
        const y = ((event.clientY - rect.top) / rect.height * 100).toFixed(2);
        section.style.setProperty('--kp-x', `${x}%`);
        section.style.setProperty('--kp-y', `${y}%`);
        section.style.setProperty('--kp-tilt-x', (x / 100 - 0.5).toFixed(3));
        section.style.setProperty('--kp-tilt-y', (y / 100 - 0.5).toFixed(3));
      });

      section.addEventListener('pointerleave', () => {
        section.style.setProperty('--kp-x', '56%');
        section.style.setProperty('--kp-y', '38%');
        section.style.setProperty('--kp-tilt-x', '0');
        section.style.setProperty('--kp-tilt-y', '0');
      });

      steps.forEach((step, index) => {
        step.addEventListener('click', () => {
          steps.forEach((item) => item.classList.remove('is-active'));
          cards.forEach((item) => item.classList.remove('is-active'));
          step.classList.add('is-active');
          if (cards[index]) cards[index].classList.add('is-active');
        });
      });

      if (reducedMotion) {
        revealItems.forEach((item) => item.classList.add('is-visible'));
        return;
      }

      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.16 });

      revealItems.forEach((item) => observer.observe(item));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sage-color-home"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const sections = document.querySelectorAll('[data-prep-flow]');

    sections.forEach((section) => {
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const cards = section.querySelectorAll('[data-flow-card]');
      const steps = section.querySelectorAll('[data-flow-step]');
      const revealItems = section.querySelectorAll('[data-flow-reveal]');

      section.addEventListener('pointermove', (event) => {
        const rect = section.getBoundingClientRect();
        const x = ((event.clientX - rect.left) / rect.width * 100).toFixed(2);
        const y = ((event.clientY - rect.top) / rect.height * 100).toFixed(2);
        section.style.setProperty('--pf-x', `${x}%`);
        section.style.setProperty('--pf-y', `${y}%`);
        section.style.setProperty('--pf-tilt-x', (x / 100 - 0.5).toFixed(3));
        section.style.setProperty('--pf-tilt-y', (y / 100 - 0.5).toFixed(3));
      });

      section.addEventListener('pointerleave', () => {
        section.style.setProperty('--pf-x', '50%');
        section.style.setProperty('--pf-y', '35%');
        section.style.setProperty('--pf-tilt-x', '0');
        section.style.setProperty('--pf-tilt-y', '0');
      });

      steps.forEach((step, index) => {
        step.addEventListener('click', () => {
          steps.forEach((item) => item.classList.remove('is-active'));
          cards.forEach((item) => item.classList.remove('is-active'));
          step.classList.add('is-active');
          if (cards[index]) cards[index].classList.add('is-active');
        });
      });

      if (reducedMotion) {
        revealItems.forEach((item) => item.classList.add('is-visible'));
        return;
      }

      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.16 });

      revealItems.forEach((item) => observer.observe(item));
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
